// extracted by mini-css-extract-plugin
export default {"container":"ytVideo_container__iqbt4","contentContainer":"ytVideo_contentContainer__Ho+8m","mainCont":"ytVideo_mainCont__RFylE"};